import { FROM_DEV, FROM_GA } from '../../constants/statuses';

export default function useGetStatus({ brand }) {
  return !!brand ? FROM_GA : FROM_DEV;
}
